import { useKycContext } from '@/providers/KycProvider'
import { useTranslations } from 'next-intl'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog'
import { IntroStep } from './IntroStep'
import { KYCStep } from './KYCStep'

export function KYCVerificationDialog() {
  const { kycStep, handleOpenChange } = useKycContext()
  const t = useTranslations()

  if (!kycStep) {
    return null
  }

  const Content = {
    intro: <IntroStep />,
    kyc: (
      <>
        {/* NOTE: Header here to cover all state cases and avoid Radix Error. Use hard coded strings since we dont display it. */}
        <DialogHeader className="sr-only">
          <DialogTitle>{t('account.kyc.dialog.title')}</DialogTitle>
          <DialogDescription>
            {t('account.kyc.dialog.description')}
          </DialogDescription>
        </DialogHeader>
        <KYCStep />
      </>
    ),
  }[kycStep]

  return (
    <Dialog open={Boolean(kycStep)} onOpenChange={handleOpenChange}>
      <DialogContent className="dark text-white">{Content}</DialogContent>
    </Dialog>
  )
}
